/* @flow */
export const getUserEntities = (state: Object) => state.entities.users;

export const getUserById = (state: Object, userId: string) => {
  let users = getUserEntities(state);
  if (!users) return null;
  return users[userId];
};



// WEBPACK FOOTER //
// ./src/redux/users/selectors.js